// extracted by mini-css-extract-plugin
export default {"rocket":"RocketCursor_rocket__tNVes","fume":"RocketCursor_fume__M0Aed","fumeAnimation":"RocketCursor_fumeAnimation__JwIOQ"};